import React from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';
import _map from 'lodash/map';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import InputTableRow from '../inputTableRow';
var SortableInputTableRow = SortableElement(InputTableRow);
var mapPropsToInputTableRow = function mapPropsToInputTableRow(_ref) {
  var columns = _ref.columns,
    getTdProps = _ref.getTdProps,
    onAction = _ref.onAction,
    errors = _ref.errors,
    getRowId = _ref.getRowId,
    rowStyle = _ref.rowStyle;
  return function (rowData, index) {
    var rowError = errors[index];
    var rowKey = getRowId(rowData) || index;
    return /*#__PURE__*/React.createElement(SortableInputTableRow, {
      key: rowKey,
      rowIndex: index,
      rowData: rowData,
      columns: columns,
      getTdProps: getTdProps,
      onAction: onAction,
      errors: rowError,
      rowStyle: rowStyle,
      index: index,
      showDraggableIcon: true
    });
  };
};
var SortableInputTableRows = function SortableInputTableRows(_ref2) {
  var data = _ref2.data,
    columns = _ref2.columns,
    getTdProps = _ref2.getTdProps,
    onAction = _ref2.onAction,
    errors = _ref2.errors,
    getRowId = _ref2.getRowId,
    rowStyle = _ref2.rowStyle;
  return /*#__PURE__*/React.createElement("div", null, _map(data, mapPropsToInputTableRow({
    columns: columns,
    getTdProps: getTdProps,
    onAction: onAction,
    errors: errors,
    getRowId: getRowId,
    rowStyle: rowStyle
  })));
};
SortableInputTableRows.propTypes = {
  data: PropTypes.array,
  columns: PropTypes.array,
  getTdProps: PropTypes.func,
  onAction: PropTypes.func,
  errors: PropTypes.array,
  getRowId: PropTypes.func,
  rowStyle: PropTypes.object
};
SortableInputTableRows.defaultProps = {
  data: EMPTY_ARRAY,
  columns: EMPTY_ARRAY,
  errors: EMPTY_ARRAY,
  getTdProps: _noop,
  onAction: _noop,
  getRowId: _noop,
  rowStyle: EMPTY_OBJECT
};
export default SortableContainer(SortableInputTableRows);